import * as R from 'ramda'

import schemaModule from '../../utils/schema/index.js'

import { dataAccess } from '../purchaseOrder/index.js'

const schema = R.pipe(
  R.dissocPath(['contents', 'items']),
  R.assocPath(['contents', 'items'], {
    type: 'Array',
    contents: [{ type: 'ObjectId', reference: 'purchaseOrderItems' }],
  }),
  schemaModule.create,
)(dataAccess.schema)

export default {
  schema,
}
